import DataFetcherTemplate from "../hooks/fetchTemplate";
import BlockRightImage from "../components/BlockRightImage";
import BlockLeftImage from "../components/BlockLeftImage";
import BlockImageCabecera from "../components/BlockImageCabecera";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import FixedHeader from "../components/FixedHeader";
import Block4ColumnsText from "../components/Block4ColumnsText";
import Block2Columns from "../components/Block2ColumnsText";
import Block2ColumnsText from "../components/Block2ColumnsText";
import MasonryGallery from "../components/MasonryGallery";
import ContentGallery from "../components/ContentGallery";
function RelacionesInterinstitucionales() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <FixedHeader
              src={item.field_portada}
              video={item.field_video_portada}
              span0="Conectamos"
              span1="a la UTPL"
              span2="con el mundo 🌎"
            ></FixedHeader>

            <div className="bluebg">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/relaciones-interinstitucionales">
                      Relaciones Interinstitucionales
                    </NavLink>
                  </>
                }
              ></Breadcumbs>
              <BlockLeftImage
                src={item.field_imagen1}
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque1,
                      }}
                    />
                  </>
                }
              >
                {" "}
              </BlockLeftImage>{" "}
            </div>

            <div className=" padding">
              <center>
                <p className="iconsize20"> 🌎</p>
                <div
                  className="layout6"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque2,
                  }}
                />
                <div className="padding2">
                  <Block4ColumnsText
                    col1={
                      <>
                        <div className="icon100">
                          <img src={item.field_imagen3} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque3,
                          }}
                        />
                      </>
                    }
                    col2={
                      <>
                        <div className="icon100">
                          <img src={item.field_imagen4} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque4,
                          }}
                        />
                      </>
                    }
                    col3={
                      <>
                        <div className="icon100">
                          <img src={item.field_imagen5} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque5,
                          }}
                        />
                      </>
                    }
                    col4={
                      <>
                        <div className="icon100">
                          <img src={item.field_imagen6} alt="utpl"></img>
                        </div>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque6,
                          }}
                        />
                      </>
                    }
                  ></Block4ColumnsText>
                </div>
                <div
                  className="width300"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque7,
                  }}
                />
              </center>
            </div>

            <div className=" culturabg padding">
              <div className="layout8">
                <p className="iconsize20"> 🎭</p>
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque8,
                  }}
                />
              </div>
              <div className="margin">
                <MasonryGallery gallery={item.field_gallery1}></MasonryGallery>
              </div>

              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque15,
                  }}
                />

                <ContentGallery gallery={item.field_spaeaker}></ContentGallery>
              </div>
            </div>

            <div className="padding lightbluebg">
              <div className="layout8">
                <p className="iconsize20">🤝</p>
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque9,
                  }}
                />
              </div>
              <center>
                <div className="margin fontsize14">
                  <Block4ColumnsText
                    col1={
                      <>
                        {" "}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque10,
                          }}
                        />
                      </>
                    }
                    col2={
                      <>
                        {" "}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque11,
                          }}
                        />
                      </>
                    }
                    col3={
                      <>
                        {" "}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque12,
                          }}
                        />
                      </>
                    }
                    col4={
                      <>
                        {" "}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: item.field_bloque13,
                          }}
                        />
                      </>
                    }
                  ></Block4ColumnsText>
                </div>
              </center>
            </div>
            <div className="icon400 padding2">
              <BlockRightImage
                src={item.field_imagen14}
                content={
                  <>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque14,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      {" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/relaciones-interinstitucionales.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <div className="layout6 padding">
        <center>
          <h2>
            <b>Contáctanos</b> si deseas generar una <b> alianza </b>con la UTPL
            o <b>conocer nuestras iniciativas</b> de cooperación académica y
            cultural.
          </h2>
          <p className="fontsize14">📩 utplglobalcampus@utpl.edu.ec</p>
        </center>
      </div>
    </>
  );
}

export default RelacionesInterinstitucionales;
